import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import Shared from 'screens/shared';

export default ({ alarmId }) => {
  const { [ACTIONS_TYPES.MONITORING.ALARM.GET_ALL_TRANSITIONS]: transitions = [] } = useSelector((e) => e);

  useEffect(() => {
    if (alarmId) {
      actions.monitoring.alarm.getAllTransitions({ alarmId });
    }
  }, [alarmId]);

  const transitionsRows = transitions.map(({ properties = {} }) => {
    const {
      newState = '', oldState = '', reason = '', date = '',
    } = properties;
    return ([
      new Date(date).toLocaleString(),
      <span className={`action-state action-state-${oldState}`}>{oldState}</span>,
      <span className={`action-state action-state-${newState}`}>{newState}</span>,
      reason,
    ]);
  });

  return (
    <div style={{ margin: 10 }}>
      <Typography variant="h5" component="h2" style={{ marginTop: 20 }}>
        {transitionsRows.length ? 'Transitions' : 'No transitions'}
      </Typography>
      <Shared.widgets.TableView
        rows={transitionsRows}
        columns={[
          { name: 'Date & Time' },
          { name: 'Old State' },
          { name: 'New State' },
          { name: 'Details' },
        ]}
        name="transitions"
      />
    </div>
  );
};
